"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "gavi": {
    "0e5558fc": [{
      "hkey": "82a23fdc",
      "slug": "fabbrica-bettolino-malvicina-via-serravalle",
      "name": "Fabbrica-Bettolino-Malvicina-Via Serravalle",
      "primary": true,
      "skipSearch": false
    }],
    "bettolino": [{
      "hkey": "82a23fdc",
      "slug": "fabbrica-bettolino-malvicina-via-serravalle",
      "name": "Fabbrica-Bettolino-Malvicina-Via Serravalle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "gavi"
    }],
    "3c9a9399": [{
      "hkey": "82a23fdc",
      "slug": "fabbrica-bettolino-malvicina-via-serravalle",
      "name": "Fabbrica-Bettolino-Malvicina-Via Serravalle",
      "primary": true,
      "skipSearch": false
    }],
    "fabbrica": [{
      "hkey": "82a23fdc",
      "slug": "fabbrica-bettolino-malvicina-via-serravalle",
      "name": "Fabbrica-Bettolino-Malvicina-Via Serravalle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "gavi"
    }],
    "d237773a": [{
      "hkey": "82a23fdc",
      "slug": "fabbrica-bettolino-malvicina-via-serravalle",
      "name": "Fabbrica-Bettolino-Malvicina-Via Serravalle",
      "primary": true,
      "skipSearch": false
    }],
    "malvicina": [{
      "hkey": "82a23fdc",
      "slug": "fabbrica-bettolino-malvicina-via-serravalle",
      "name": "Fabbrica-Bettolino-Malvicina-Via Serravalle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "gavi"
    }],
    "50b7c9af": [{
      "hkey": "0b4ba69c",
      "slug": "gavi",
      "name": "Gavi",
      "primary": true,
      "skipSearch": false
    }],
    "monterotondo": [{
      "hkey": "0b4ba69c",
      "slug": "gavi",
      "name": "Gavi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5b7dcdb9": [{
      "hkey": "0b4ba69c",
      "slug": "gavi",
      "name": "Gavi",
      "primary": true,
      "skipSearch": false
    }],
    "raineri": [{
      "hkey": "0b4ba69c",
      "slug": "gavi",
      "name": "Gavi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "634de4b3": [{
      "hkey": "0b4ba69c",
      "slug": "gavi",
      "name": "Gavi",
      "primary": true,
      "skipSearch": false
    }],
    "sottovalle": [{
      "hkey": "0b4ba69c",
      "slug": "gavi",
      "name": "Gavi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;